/**
 * Created by Ning Jiang on 2022-05-06.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {DeadwoodRip} from "../../DeadwoodRip";
import {DeadwoodRipLayers, Layers} from "../../view/DeadwoodRipLayers";
import {IBetWayWinData} from "../../server/data/IDeadwoodRipData";
import {DeadwoodRipReelController} from "../../reels/DeadwoodRipReelController";
import {DeadwoodRipReelView} from "../../reels/DeadwoodRipReelView";
import {DeadwoodRipSound} from "../../sound/DeadwoodRipSound";

export class SymbolWinHighlightController extends ReelStopPresentationController {

    private _layer:StageLayer;
    private _positionPlayed:boolean[][];
    private _highlightSoundPlayedReel:number;

    constructor() {
        super("SymbolWinHighlightController");
        this._layer = DeadwoodRipLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        if(data.reelId < 2) {
            return Promise.resolve();
        }

        if(this.playHighlightSymbolsOnReel(data.reelId, true) && data.reelId === 2) {
            for(let reelId = 0; reelId < data.reelId; reelId++) {
                this.playHighlightSymbolsOnReel(reelId, false);
            }
        }
        return Promise.resolve();
    }

    private playHighlightSymbolsOnReel(reelId:number, playSound:boolean = true):boolean {
        let result = false;

        for(let symId = 0; symId < 3; symId++) {
            result = this.playHighlightOnSymbol(reelId, symId, playSound) || result;
        }

        return result;
    }

    private playHighlightOnSymbol(reelId:number, symbolId:number, playSound:boolean):boolean {
        if(this._positionPlayed[reelId][symbolId]) {
            return false;
        }

        let result = false;
        DeadwoodRip.model.parsedGameData.betWinsBeforeReveal.forEach(betWin => {
            result = (<IBetWayWinData>betWin).reelWinPositions[reelId][symbolId] || result;
        });

        if(result) {
            this._positionPlayed[reelId][symbolId] = true;
            this.playWinHighlightAnimation(reelId, symbolId, playSound);
        }

        return result;
    }

    private playWinHighlightAnimation(reelId:number, symbolId:number, playSound:boolean):void {
        const effect = DeadwoodRip.winView.getWinEffect(DeadwoodRipReelView.getGlobalPosition(reelId, symbolId));
        const tl = new TimelineLite();
        tl.add(() => {
            this._layer.addChild(effect);
            if(playSound && this._highlightSoundPlayedReel < reelId) {
                this._highlightSoundPlayedReel = reelId;
                const sound = DeadwoodRipSound.playReelWinHighlightSound();
                if(sound) {
                    sound.player.stereo(DeadwoodRipSound._davidPanningReelStop[reelId]);
                }
                // SerialSound.soundPlayer.playTrack({name : Serial.model.parsedGameData.mode.includes("FREESPIN") ? SerialSound.WIN_HIGHLIGHT_FS : SerialSound.WIN_HIGHLIGHT});
            }
        });
        tl.add(effect.playHintEffect());
        tl.add(() => {
            DeadwoodRip.winView.removeWinEffect(effect);
        });
    }

    protected reset() {
        super.reset();
        this._highlightSoundPlayedReel = -1;
        this._positionPlayed = ArrayHelper.initArrayWithValues<boolean[]>(DeadwoodRipReelController.SYMBOLS_NUM_IN_DATA.length, () => {
            return ArrayHelper.initArrayWithValues<boolean>(3, () => false)
        });
    }
}